import Vue from 'vue';

/**
 * You can use a functional component to render the vnodes for that section of your template:
 *
 * ```xml
 * <some-component>
 *   <div slot-scope="{ vnodes }">
 *     <vnodes :vnodes="vnodes"/>
 *   </div>
 * </some-component>
 * ```
 *
 * 在需要这个能力的地方
 *
 * ```
 * components: {
 *   Vnodes,
 * }
 * ```
 */

const VNodes = {
  functional: true,
  render: (h, ctx) => {
    if (!VNodeCtor) VNodeCtor = h('h1').constructor;
    const nodes = ctx.props.vnodes;
    if (nodes.constructor !== VNodeCtor && (!Array.isArray(nodes) || nodes.length > 1)) {
      return h('div', nodes);
    }
    return nodes;
  }
};
let VNodeCtor;
export { VNodes };
//# sourceMappingURL=VNodes.js.map
